export default __webpack_public_path__ + "static/media/bg.81a5f942.png";